/**
 * IANA timezone → primary ISO 3166-1 alpha-2 country code.
 *
 * Only zones that `moment.tz.zone(tz).countries()` resolves incorrectly need
 * an entry here; everything else falls through to that list.
 *
 * Two cases are covered:
 *
 * 1. Zones shared by several countries. `countries()` returns them
 *    ALPHABETICALLY, not primary-country-first, so taking the first entry
 *    picks a neighbour: Asia/Tokyo → AU, America/Toronto → BS,
 *    Africa/Nairobi → DJ, Asia/Riyadh → AQ (Antarctica). The zone is named
 *    after a city in its primary country, which is what we record here.
 *
 * 2. Deprecated zones still offered by the `timezones-list` package used in
 *    the signup/settings pickers. The tz database dropped their country
 *    metadata after merging them into another zone, so `countries()` comes
 *    back empty and detection would fall back to USD.
 *
 * Europe/Simferopol is intentionally absent: its primary country is disputed,
 * so it keeps the default resolution rather than having one asserted here.
 */
export const ZONE_PRIMARY_COUNTRY = {
  // --- Shared zones: named for a city in the country listed ---
  'Africa/Abidjan': 'CI',
  'Africa/Johannesburg': 'ZA',
  'Africa/Lagos': 'NG',
  'Africa/Maputo': 'MZ',
  'Africa/Nairobi': 'KE',
  'America/Panama': 'PA',
  'America/Phoenix': 'US',
  'America/Puerto_Rico': 'PR',
  'America/Toronto': 'CA',
  'Asia/Bangkok': 'TH',
  'Asia/Dubai': 'AE',
  'Asia/Kuching': 'MY',
  'Asia/Qatar': 'QA',
  'Asia/Riyadh': 'SA',
  'Asia/Singapore': 'SG',
  'Asia/Tokyo': 'JP',
  'Asia/Yangon': 'MM',
  'Europe/Belgrade': 'RS',
  'Europe/Berlin': 'DE',
  'Europe/London': 'GB',
  'Europe/Prague': 'CZ',
  'Europe/Zurich': 'CH',
  'Indian/Maldives': 'MV',
  'Pacific/Auckland': 'NZ',
  'Pacific/Guadalcanal': 'SB',
  'Pacific/Port_Moresby': 'PG',
  'Pacific/Tarawa': 'KI',

  // --- Deprecated zones with no country metadata left ---
  'America/Godthab': 'GL',
  'America/Nipigon': 'CA',
  'America/Pangnirtung': 'CA',
  'America/Rainy_River': 'CA',
  'America/Thunder_Bay': 'CA',
  'America/Yellowknife': 'CA',
  'Asia/Choibalsan': 'MN',
  'Australia/Currie': 'AU',
  'Europe/Uzhgorod': 'UA',
  'Europe/Zaporizhzhia': 'UA',
  'Pacific/Enderbury': 'KI',
}

export default ZONE_PRIMARY_COUNTRY
